// @flow
import $ from 'jquery';

export default function flashMessage(
  message: string,
  type: string,
  position: string = 'bottom',
  delay: number = 3000,
  locale: string = '',
) {
  message = escapeHTML(message);
  const template =
    '<div data-notify="container">' +
    '<div class="d-flex justify-content-center component-v2">' +
    `<div class="alert alert-bar alert-${
      type === 'success' ? 'black' : 'danger'
    } flash-message">` +
    '<span class="message">' +
    `${
      type === 'success' ? '<i class="icon ion-checkmark mr-2"></i>' : ''
    }{2}` +
    '</span>' +
    '<button type="button" class="close-button" data-dismiss="alert">' +
    `${locale == 'en' ? 'close' : '閉じる'}` +
    '</button>' +
    '</div>' +
    '</div>' +
    '</div>';
  $.notify(
    {
      icon: '',
      title: '',
      message,
      url: '',
      target: '_blank',
    },
    {
      element: 'body .notify',
      position: 'fixed',
      type,
      allow_dismiss: true,
      newest_on_top: false,
      showProgressbar: false,
      placement: {
        from: position,
        align: 'center',
      },
      offset: 60,
      spacing: 10,
      z_index: 1051, //モーダルのバックドロップの上に表示する場合を考慮
      delay: delay,
      timer: 1000,
      url_target: '_blank',
      mouse_over: null,
      animate: {
        enter: '',
        exit: '',
      },
      onShow: null,
      onShown: null,
      onClose: null,
      onClosed: null,
      icon_type: 'class',
      template: template,
    },
  );

  function escapeHTML(message: string) {
    // js.erbからnotifyが呼び出された場合にはエスケープ済みでcontrollerからnotifyを呼び出すと未エスケープ
    // エスケープ状態を合わせるため、一旦エスケープを解除してから再度エスケープを行なっている。
    return message
      .replace(/&lt;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#x27;/g, "'")
      .replace(/&/g, '&lt;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;');
  }
}
